export const APPROVE = "APPROVE";
export const REJECT = "REJECT";
export const CHANGE_PRIMARY_ADMIN = "CHANGE_PRIMARY_ADMIN";
export const PENDING = "PENDING";
export const INPROGRESS = "IN PROGRESS";
export const DISABLE_ACTION_STATUS = ["APPROVE", "REJECT", "IN PROGRESS", "CANCEL"];
export const QUERYID = "approvalId";
export const CANCEL = "CANCEL";
export const THREE_DECIMAL_PRICE_COUNTRIES = ["BH", "JO", "KW", "OM"];
export const CREDIT_CARD = "Credit_Card";
export const PAYPAL = "PayPal";
export const PURCHASE_ORDER = "Purchase_Order";
export const DIRECT_DEBIT = "Direct_Debit";
export const BILLING_FREQUENCY_ANNUAL = "ANNUAL";
export const BILLING_FREQUENCY_MONTHLY = "MONTHLY";
export const AUTO_RENEWAL_COUNTRIES = ["US"];
export const ENABLE_I2T_BANNER = "ENABLE_I2T_FLOW";
export const ENABLE_FP_BANNER = "ENABLE_FP_BANNER";
export const ENABLE_APPROVAL_ANALYTICS_LOG = "ENABLE_APPROVAL_ANALYTICS_LOG";
export const BNPL = "BNPL";
export const KLARNA = "KLARNA";
export const LPM = "LPM";
export const EXTERNAL_WALLET = "EXTERNAL_WALLET";
export const AMAZON_PAY = "AMAZON_PAY";
export const LPM_PAYMENT_LIST_FOR_EMAIL_PHONE = ["ALIPAYHK","GCASH","TRUEMONEY","DANA","TOUCHNGO"];
export const LPM_PAYMENT_LIST_FOR_PHONE_NUMBER = ["PAYPAY"];
export const NUPAY_PAYMENT = "NUPAY";
export const NO_DECIMAL_PRICE_COUNTRIES = ["JP"];
export const AGREEMENT_PRICE_COLUMN_KEYS = ['annualUnitPrice', 'termUnitPrice', 'totalPrice'];
